import { useEffect, useRef } from "react";

type RecoveryCallback = () => void;

export function useLizeraStaleStateRecovery(onRecover?: RecoveryCallback) {
const lastTime = useRef(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const gap = now - lastTime.current;

      // Only trigger if gap is very large (e.g., 60 seconds)
      if (gap > 60000) { // 60000ms = 1 minute
        console.log(`⏰ System wake detected, gap: ${gap}ms`);
        if (onRecover) {
          onRecover();
        } else {
          window.location.reload();
        }
      }

      lastTime.current = now;
    }, 5000); // check every 5 seconds

    const handleOnline = () => {
      console.log("🌐 Back online, refreshing...");
      if (onRecover) {
        onRecover();
      } else {
        window.location.reload();
      }
    };

    window.addEventListener("online", handleOnline);

    return () => {
      clearInterval(interval);
      window.removeEventListener("online", handleOnline);
    };
  }, [onRecover]);
}
